export interface HistoryExamineEntities {
  activity: string;
  createAt: string;
  examineGroupId: string;
  historyExamineGroupId: string;
  role: string;
  updateAt: string;
  updatedBy: string;
}
export const HistoryExamineEntities_INIT: HistoryExamineEntities = {
  activity: "",
  createAt: "",
  examineGroupId: "",
  historyExamineGroupId: "",
  role: "",
  updateAt: "",
  updatedBy: "",
};
